import getTotalRateDiscounted from './getTotalRateDiscounted'
import getPaxForPersons from './getPaxForPersons'
import getTotalRateBeforeDiscount from './getTotalRateBeforeDiscount'
import { getNumberOfChildrenWithPercentageValues } from './getNumberOfChildrenWithPercentageValues'
import { getNumberOfChildrenTreatedAsAdults } from './getNumberOfChildrenTreatedAsAdults'
import getChildrenSelectedCategories from './getChildrenSelectedCategories'
import getTotalOBPRate from './getTotalOBPRate'
import getExcludedServicesTotal from './getExcludedServicesTotal'
import getTotalPPPDRate from './getTotalPPPDRate'
import getExtraPersonCharge from './getExtraPersonCharge'
import getChildrenExtraCharge from './getChildrenExtraCharge'

const getTotalRate = (unitTypeOccupancy, ratePlan, adults, childrenAges) => {
  if (!ratePlan) {
    return 0
  }

  if (ratePlan.activePromoCode) {
    return getTotalRateDiscounted(unitTypeOccupancy, ratePlan, adults, childrenAges)
  }

  if (ratePlan.isPaxRate) {
    return (
      getTotalOBPRate(ratePlan, adults, childrenAges, unitTypeOccupancy) +
      getExcludedServicesTotal(ratePlan, adults, childrenAges)
    )
  }

  if (ratePlan.isPPPDRate) {
    return getTotalPPPDRate(ratePlan, adults, childrenAges) + getExcludedServicesTotal(ratePlan, adults, childrenAges)
  }

  return (
    ratePlan.totalRate +
    getExcludedServicesTotal(ratePlan, adults, childrenAges) +
    getExtraPersonCharge(unitTypeOccupancy, ratePlan, adults) +
    getChildrenExtraCharge(unitTypeOccupancy, ratePlan, childrenAges)
  )
}

const getAverageRate = (unitTypeOccupancy, ratePlan, adults, childrenAges) => {
  if (!ratePlan) {
    return 0
  }

  const { nights } = ratePlan
  const totalRate = getTotalRate(unitTypeOccupancy, ratePlan, adults, childrenAges)

  return totalRate / nights
}

export {
  getTotalRate,
  getAverageRate,
  getTotalRateBeforeDiscount,
  getPaxForPersons,
  getNumberOfChildrenWithPercentageValues,
  getNumberOfChildrenTreatedAsAdults,
  getChildrenSelectedCategories
}
